<template>
    <page-section class="page-section--last page-section--sm">
        <template #tit>기술력으로 증명하는 <span class="primary--text">유산균 전문기업</span></template>
        <template #txt>
            <span class="grey--text text--darken-4">
                (주)웰빙엘에스는 국내 최고 수준의 식물성유산균 기술력을 바탕으로 <br class="d-none d-lg-block" />
                다양한 프로바이오틱스 및 포스트바이오틱스 제품과 발효제품을 개발하고 있습니다.
            </span>
        </template>

        <v-sheet class="company-content">
            <v-row justify="center" no-gutters>
                <v-col cols="12" xl="10">
                    <v-row justify="center" class="row--xxl mb-0">
                        <v-col v-for="item in items" :key="item.name" cols="6" lg="3" class="company-item">
                            <v-card>
                                <div>
                                    <v-img :src="item.icon" alt="" max-width="40" class="mx-auto" />
                                    <div class="txt txt--lg txt--dark font-weight-bold mt-4">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </v-card>
                            <p v-html="item.text" class="text-center txt txt--lg txt--dark font-weight-bold" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-sheet>

        <v-sheet class="company-content">
            <div class="tit-wrap--lg text-center">
                <h3 class="tit tit--sm font-weight-medium">주요 특허 등록</h3>
            </div>
            <v-sheet color="grey lighten-5" rounded="xl" class="patent-wrap">
                <v-row justify="center" class="row--lg">
                    <v-col v-for="patent in patents" :key="patent.number" cols="6" lg="4" xl="">
                        <div class="txt txt--sm txt--dark d-flex justify-center align-center">
                            <v-icon color="primary" small class="mr-1">mdi-checkbox-marked-outline</v-icon>
                            <span class="font-weight-medium">{{ patent.number }}</span>
                        </div>
                        <v-img :src="patent.image" alt="" max-width="170" class="mx-auto my-10px" />
                        <div v-html="patent.name" class="txt txt--lg txt--dark font-weight-bold text-center" />
                    </v-col>
                </v-row>
            </v-sheet>
            <div class="d-flex justify-center align-start text-center mt-6 mt-md-10">
                <img src="/images/icon/icon-quote-open.svg" alt="" width="18" />
                <div class="tit tit--xs mx-1">그 외 총 <span class="primary--text">26건 특허, 12건 디자인, 55건 상표</span> 보유</div>
                <img src="/images/icon/icon-quote-close.svg" alt="" width="18" />
            </div>
            <v-row>
                <v-col cols="auto"> </v-col>
            </v-row>
        </v-sheet>

        <v-sheet class="company-content">
            <marks-list />
        </v-sheet>
    </page-section>
</template>

<script>
import PageSection from "@/components/client/templates/page-section.vue";
import MarksList from "../dumb/marks-list.vue";

export default {
    components: {
        PageSection,
        MarksList,
    },
    data() {
        return {
            items: [
                {
                    name: "내산성",
                    text: "PH 2.0 조건에서도 <br />1,000배 높은 생존율",
                    icon: "/images/about/company-1.svg",
                },
                {
                    name: "내열성",
                    text: "90°C 조건<br />에서도 생존",
                    icon: "/images/about/company-2.svg",
                },
                {
                    name: "장 정착성",
                    text: "장 점착력 테스트 <br />우수 결과",
                    icon: "/images/about/company-3.svg",
                },
                {
                    name: "면역력 실험",
                    text: "Endorphin <br />유의미한 증가",
                    icon: "/images/about/company-4.svg",
                },
                {
                    name: "혈당조절 효과",
                    text: "식물성유산균 농도별 <br />혈당 감소 확인",
                    icon: "/images/about/company-5.svg",
                },
                {
                    name: "충치유발 억제",
                    text: "식물성유산균 <br />충치유발 억제",
                    icon: "/images/about/company-6.svg",
                },
                {
                    name: "장내 염증 억제",
                    text: "식물성유산균 <br />장내 염증 억제",
                    icon: "/images/about/company-6.svg",
                },
            ],
            patents: [
                {
                    number: "제 1192765호",
                    name: "식물성유산균 <br />제조 관련 특허",
                    image: "/images/about/patent-1.jpg",
                },
                {
                    number: "제 1776613호",
                    name: "포스트바이오틱스 <br />유산균생성물질 특허",
                    image: "/images/about/patent-2.jpg",
                },
                {
                    number: "제 1298557호",
                    name: "발효커피 <br />관련 특허",
                    image: "/images/about/patent-3.jpg",
                },
                {
                    number: "제 2078324호",
                    name: "술애타유 <br />국내 특허",
                    image: "/images/about/patent-4.jpg",
                },
                {
                    number: "ZL 2019800949224",
                    name: "술애타유 <br />중국 특허",
                    image: "/images/about/patent-5.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.company-item {
    padding-bottom: 0 !important;
    .v-card {
        aspect-ratio: 1;
        border-width: 8px;
        border-style: solid;
        border-radius: 50% !important;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 12px;
    }
    &:nth-child(2n-1) {
        .v-card {
            border-color: var(--v-light-blue-base);
        }
    }
    &:nth-child(2n) {
        .v-card {
            border-color: #00bfa1;
        }
    }
}
.patent-wrap {
    padding: 20px;
}
.company-content + .company-content {
    padding-top: 40px;
}
@media (min-width: 768px) {
    .patent-wrap {
        padding: 40px;
    }
    .company-item {
        .v-card {
            border-width: 16px;
            margin-bottom: 20px;
        }
    }
    .company-content + .company-content {
        padding-top: 60px;
    }
}
@media (min-width: 1024px) {
    .ceo-image {
        transform: translateY(var(--page-section-padding-y-sm));
    }
    .company-item {
        .v-card {
            margin-bottom: 24px;
        }
    }
    .company-content + .company-content {
        padding-top: 100px;
    }
    .patent-wrap {
        padding: 40px 80px;
    }
}
</style>